<template>
	<v-row
		class="align-content"
		justify="center"
	>
		<v-col
			class="xs"
			sm="8"
			md="8"
			lg="6"
		>
			<v-row>
				<v-col>
					<v-card class="elevation-12">
						<v-toolbar
							dark
							color="primary"
						>
							<v-toolbar-title>הרשמה</v-toolbar-title>
							<v-spacer />
						</v-toolbar>
						<form
							ref="form"
							@submit.prevent="onSubmit"
						>
							<v-card-text>
								<smart-input
									v-model="form.name"
									:required="true"
									:errors="inputErrors.name"
									prepend-icon="mdi-account"
									name="register"
									label="שם מלא"
									type="text"
								/>
								<smart-input
									v-model="form.email"
									:errors="inputErrors.email"
									:required="true"
									prepend-icon="mdi-account"
									name="register"
									label="דואר אלקטרוני"
									type="email"
								/>
								<smart-input
									id="password"
									v-model="form.password"
									:errors="inputErrors.password"
									required
									prepend-icon="mdi-lock"
									name="password"
									label="סיסמא"
									type="password"
								/>
								<smart-input
									id="confirmationPassword"
									v-model="form.password_confirmation"
									name="password_confirmation"
									required
									prepend-icon="mdi-lock"
									label=" אימות סיסמא"
									type="password"
								/>
							</v-card-text>
							<v-card-actions class="d-flex flex-column">
								<v-btn
									type="submit"
									color="#a82c9c"
									style="color:white;"
								>
									הרשמה
								</v-btn>
								<router-link
									to="/login"
									class="my-3"
								>
									רשומים כבר? התחברו
								</router-link>
								<v-btn
									class="d-flex justify-space-between primary"
									@click="googleLogin"
								>
									<v-icon class="red--text ml-3">
										mdi-google
									</v-icon>
									<span>התחבר באמצעות גוגל</span>
								</v-btn>
							</v-card-actions>
						</form>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
	import UserModule from "src/store/modules/User.module";
	import FormView from "src/mixins/FormView";
	import AuthService from "src/packages/AuthService";
	import LaravelErrors from "@/helpers/LaravelErrors";

	export default {
		name: "registration",
		data: () => ({
			disabled: false,
			form: {},
			inputErrors: {},
		}),
		computed: {},
		// mixins: [new FormView(UserModule, 'user')],
		methods: {
			async   onSubmit () {
				this.disabled = true;
				try {
					await AuthService.register(this.form);
					this.$router.push({ name: "main-dashboard" });
				} catch (error) {
					if (error.response && error.response.status === 422 && error.response.data && error.response.data.errors) {
						this.inputErrors = LaravelErrors.getFirstErrorOnly(error.response.data.errors);
					}
				}
			},
			googleLogin () {
				window.location = "/login/google";
			},
			redirectToLogin () {
				this.$router.push({ name: "Login" });
			},
		},
	};
</script>

<style scoped>

</style>
